export default "__VITE_ASSET__Jk0SHWGn__"